import React from 'react';
import { languages, getSelectedLanguage } from '../languages';

const Loader = ({ title, description, compact = false, fullScreen = false }) => {
    const t = languages[getSelectedLanguage()] || languages.Pt;
    const loaderTitle = title || t.loading_data || t.loading || 'Carregando...';
    const loaderDescription = description === undefined ? t.loading_environment : description;

    return (
        <div className={`${fullScreen ? 'fiscal-loading-screen' : ''}`}>
            <div className={`fiscal-loading-state ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
                <span className="fiscal-loading-icon" aria-hidden="true">
                    <i className="mdi mdi-loading"></i>
                </span>
                <span className="fiscal-loading-copy">
                    <strong>{loaderTitle}</strong>
                    {loaderDescription && <small>{loaderDescription}</small>}
                </span>
            </div>
        </div>
    );
};

export default Loader;
